/*
  Size chart pop-up: IN / CM toggle (remembered in localStorage) and the column hover highlight.
  Row hover is pure CSS; the column needs a hand because CSS cannot select a column, so the cells of the hovered
  column get .is-col-hover (see assets/toko-size-chart.css).
*/
(function () {
  var KEY = 'toko-size-unit';

  function setUnit(root, unit, save) {
    if (!root) return;
    root.setAttribute('data-unit', unit);
    var btns = root.querySelectorAll('.tsc-toggle__btn');
    for (var i = 0; i < btns.length; i++) {
      var on = btns[i].getAttribute('data-unit') === unit;
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    if (save) { try { localStorage.setItem(KEY, unit); } catch (e) {} }
  }

  function init() {
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    if (saved !== 'in' && saved !== 'cm') saved = 'in';
    var roots = document.querySelectorAll('.tsc');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].__tscInit) continue;
      roots[i].__tscInit = true;
      setUnit(roots[i], saved, false);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.tsc-toggle__btn');
    if (!btn) return;
    e.preventDefault();
    setUnit(btn.closest('.tsc'), btn.getAttribute('data-unit'), true);
  });

  function clearCol(table) {
    table.__tscCol = null;
    var on = table.querySelectorAll('.is-col-hover');
    for (var i = 0; i < on.length; i++) on[i].classList.remove('is-col-hover');
  }

  document.addEventListener('mouseover', function (e) {
    var cell = e.target.closest && e.target.closest('.tsc-table th, .tsc-table td');
    if (!cell) return;
    var table = cell.closest('table');
    var idx = cell.cellIndex;
    if (table.__tscCol === idx) return;
    clearCol(table);
    table.__tscCol = idx;
    var rows = table.rows;
    for (var r = 0; r < rows.length; r++) {
      var c = rows[r].cells[idx];
      if (c) c.classList.add('is-col-hover');
    }
  });

  document.addEventListener('mouseout', function (e) {
    var table = e.target.closest && e.target.closest('.tsc-table');
    if (!table) return;
    var to = e.relatedTarget;
    if (to && table.contains(to)) return;
    clearCol(table);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
